import { Skeleton } from 'antd';

export type LoadMoreSkeletonProps = {
  initialLoading: boolean;
  hasNextPage: boolean;
  loadNextRef: (node?: Element | null | undefined) => void;
};

export function LoadMoreSkeleton({ initialLoading, hasNextPage, loadNextRef }: LoadMoreSkeletonProps) {
  if (initialLoading || hasNextPage) {
    return (
      <div ref={loadNextRef}>
        <Skeleton active paragraph={false} />
      </div>
    );
  }
}
